import { createContext } from 'react';
import type { LoggingContextType } from './Logging.type.ts';

export const LoggingContext = createContext<LoggingContextType | null>(null);
